<template>
  <div>
    <section class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">Login</h1>
        </div>
        <div class="columns is-vcentered">
          <div class="column is-6 is-offset-3">
            <article
              v-show="!sent && registered"
              class="message icon-msg success-msg"
            >
              <i class="material-icons">assignment_turned_in</i>
              <div class="message-body">
                <h4>You've signed up successfully!</h4>
                <p>Please login with your login details below.</p>
              </div>
            </article>
            <div class="flex-card light-bordered light-raised">
              <div class="card-body">
                <article v-show="redirect" class="message icon-msg info-msg">
                  <div class="message-body">
                    <h4>You need to log in to continue</h4>
                  </div>
                </article>
                <ValidationObserver ref="observer" v-slot="{ passes }">
                  <form v-show="!sent" @submit.prevent="passes(submit)">
                    <div class="columns">
                      <div class="column">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Email Address"
                            rules="required|email"
                          >
                            <b-field
                              label="Email Address"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input
                                v-model="item.email"
                                type="email"
                                name="email"
                                autocomplete="email"
                              >
                              </b-input>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="column">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Password"
                            rules="required"
                          >
                            <b-field
                              label="Password"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input
                                v-model="item.password"
                                type="password"
                                password-reveal
                              >
                              </b-input>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                    <div class="has-text-centered">
                      <span class="is-size-6">
                        <a href="/forgot-password">Forgot Password?</a></span
                      >
                      <br /><br />
                      <div class="is-block has-text-centered">
                        <button
                          class="button is-primary btn-align no-lh raised primary-btn"
                          type="submit"
                          :disabled="loading"
                          :class="{ 'is-loading': loading }"
                        >
                          Login</button
                        ><br />
                        <small v-if="showError" class="is-danger">
                          {{ errorMessage }}
                        </small>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </CardComponent>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CardComponent from '@/components/CardComponent'
export default {
  name: 'Login',
  components: {
    CardComponent
  },
  metaInfo: {
    title: 'Login'
  },
  data() {
    return {
      item: {
        email: '',
        password: ''
      },
      registered: false,
      loading: false,
      sent: false,
      showError: false
    }
  },
  computed: {
    ...mapGetters(['user', 'isAuthenticated']),
    redirect() {
      return this.$route.query.redirect
    }
  },
  watch: {
    isAuthenticated() {
      if (this.user && !this.user.verified) {
        this.$router.push({ name: 'VerifyEmail' })
      } else {
        if (this.$route.query && this.$route.query.redirect) {
          this.$router.push({ path: this.$route.query.redirect })
        } else {
          this.$router.push({ name: 'ManageMedia' })
        }
      }
    }
  },
  created() {
    if (this.$route.query.register) {
      this.registered = true
    }
  },
  methods: {
    ...mapActions(['login']),
    submit() {
      this.showError = false
      this.errorMessage = ''
      this.loading = true
      this.login(this.item)
        .then(response => {
          if (!response.verified) {
            this.$router.push({ name: 'VerifyEmail' })
          } else {
            if (this.$route.query && this.$route.query.redirect) {
              this.$router.push({ path: this.$route.query.redirect })
            } else {
              this.$router.push({ name: 'Home' })
            }
          }

          this.loading = false
        })
        .catch(err => {
          let message = 'Error logging in'
          if (err && err.data && err.data.err) {
            message = 'Invalid email or password'
          }
          this.$buefy.toast.open({
            message: message,
            position: 'is-top',
            type: 'is-danger'
          })
          this.loading = false
        })
    }
  }
}
</script>
